/* Keep native mega-menu transitions and add keyboard disclosure controls. */
(() => {
  const desktop = window.matchMedia('(min-width: 1151px)');
  const initialize = (root = document) => {
    root.querySelectorAll('mega-menu-horizontal.bot-desktop-menu, mega-menu-horizontal.bot-brands-menu').forEach(menu => {
      if (menu.dataset.keyboardReady) return;
      menu.dataset.keyboardReady = 'true';
      const details = menu.querySelector('details');
      const summary = details.querySelector('summary');
      const panel = summary.nextElementSibling;
      const focusFirst = () => panel.querySelector('a[href]')?.focus();
      const updateHeight = () => {
        const top = details.open ? panel.getBoundingClientRect().top : menu.closest('.header').getBoundingClientRect().bottom;
        menu.style.setProperty('--bot-menu-top', `${Math.max(0, top)}px`);
      };
      summary.addEventListener('mouseenter', updateHeight);
      details.addEventListener('toggle', () => { if (details.open) updateHeight(); });
      window.addEventListener('resize', updateHeight);
      const close = async (returnFocus = false) => {
        menu.cancelShow();
        menu.cancelHide();
        if (menu.state === 'fading-in') {
          menu.currentAnim?.cancel();
          menu.setState('open');
        }
        await menu.hide();
        if (returnFocus && desktop.matches && summary.getClientRects().length) summary.focus();
      };
      // A hover opening can still be awaiting its delay when the viewport changes.
      const originalShow = menu.show.bind(menu);
      menu.show = async (...args) => {
        if (!desktop.matches) return;
        await originalShow(...args);
        if (!desktop.matches) await close();
      };
      summary.addEventListener('click', event => {
        if (desktop.matches) { event.preventDefault(); updateHeight(); }
      });
      menu.addEventListener('keydown', async event => {
        if (!desktop.matches) return;
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          await close(true);
        } else if (event.target === summary && ['Enter', ' ', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          menu.cancelHide();
          menu.cancelShow();
          updateHeight();
          if (details.open && event.key !== 'ArrowDown') await close();
          else {
            await menu.show({trigger: 'keyboard'});
            if (event.key === 'ArrowDown') focusFirst();
          }
        }
      });
      menu.addEventListener('focusin', () => menu.cancelHide());
      [summary, panel].forEach(element => {
        element.addEventListener('mouseleave', () => {
          if (menu.contains(document.activeElement)) menu.cancelHide();
        });
      });
      menu.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement) && details.open) close();
        });
      });
      document.addEventListener('pointerdown', event => {
        if (details.open && !event.target.closest('.header mega-menu-horizontal')) close();
      });
      desktop.addEventListener('change', async () => {
        if (desktop.matches) return;
        const heldFocus = menu.contains(document.activeElement);
        await close();
        if (heldFocus && !desktop.matches && (document.activeElement === document.body || menu.contains(document.activeElement))) {
          const compactTrigger = document.querySelector('#shopBtn1');
          if (compactTrigger?.getClientRects().length) compactTrigger.focus({preventScroll: true});
        }
      });
    });
  };
  customElements.whenDefined('mega-menu-horizontal').then(() => {
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  });
})();
